import { BrowserModule } from "@angular/platform-browser";
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { QRCodeComponent } from "angularx-qrcode";

import {
  NbThemeModule,
  NbLayoutModule,
  NbActionsModule,
  NbSidebarModule,
  NbMenuModule,
  NbIconModule,
  NbButtonModule,
  NbDatepickerModule,
  NbDialogModule,
  NbToastrModule,
} from "@nebular/theme";
import { NbMomentDateModule } from "@nebular/moment";
import { NbEvaIconsModule } from "@nebular/eva-icons";
import { Globals } from "./globals";

// Services
import { AzureService } from "./services/azure.service";
import { SetupService } from "./services/setup.service";
//v2-import { FullProfileService } from "./services/full-profile.service";
import { ErrorComponent } from "./error/error.component";
@NgModule({
  declarations: [AppComponent, ErrorComponent],
  imports: [
    BrowserModule,
    ScrollingModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    NbThemeModule.forRoot({ name: "default" }),
    NbLayoutModule,
    NbActionsModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbToastrModule.forRoot(),
    NbEvaIconsModule,
    NbIconModule,
    NbButtonModule,
    NbMomentDateModule,
    QRCodeComponent,
  ],
  //v2-providers: [Globals, AzureService, SetupService, FullProfileService],
  providers: [Globals, AzureService, SetupService],
  bootstrap: [AppComponent],
})
export class AppModule {}
